import { createSelector } from "@reduxjs/toolkit";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import companyToken from "Utils/companyToken";
import { fetchWithCSRFTokenForRequestObject } from "Utils/fetchWithCSRFToken";
import { partnerType } from "Utils/isPartner";

import { appendAuthParams } from "Common/TokenAuth/Utils";

export const payrollLead = createApi({
  reducerPath: "payrollLead",
  baseQuery: fetchBaseQuery({
    baseUrl: "/api/v2",
    fetchFn: fetchWithCSRFTokenForRequestObject,
  }),
  endpoints: (builder) => ({
    getCallToActionData: builder.query({
      query: () => {
        const companyIDToken = companyToken();
        const data = {
          partner: partnerType(),
          ...(companyIDToken ? { company_id_token: companyIDToken } : {}),
        };
        const params = new URLSearchParams(data).toString();
        return appendAuthParams(`/payroll_lead_call_to_action?${params}`);
      },
    }),
  }),
});

export const { useGetCallToActionDataQuery } = payrollLead;
